module.exports = __webpack_public_path__ + "static/media/Madfit-10.ef6e55ac.jpg";